import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useDialogFormStore } from '@/components/dialog/form.store';
import { subGroupClubGallery } from '@/services/groupsManagement/subGroupClubGallery.types';
import * as React from 'react';
import { ManageGroupsForm } from '../../ManageGroupsForm';
import { getColumns } from './Column';

export function SubGroupClubGalleryTable({ data }: { data: subGroupClubGallery[] }) {
  const columns = React.useMemo(() => getColumns(), []);
  const { onOpen } = useDialogFormStore();

  const onAddNew = () => {
    onOpen({
      title: 'Add New Group',
      okText: 'Create',
      size: 'lg',
      modalTitle: 'configurationManagement.groupsManagement.manageGroups.title',
      component: (
        <ManageGroupsForm
          defaultValues={{
            groupName: '',
            groupNameKatakana: '',
            groupCoverImage: '',
            description: '',
          }}
        />
      ),
    });
  };

  const { table } = useDataTable({
    data,
    columns,
    pageCount: 0,
    initialState: {
      sorting: [{ id: 'id', desc: true }],
      columnPinning: { right: ['actions'] },
    },
    meta: {
      title: 'Sub Group Club Gallery',
      action: onAddNew,
      actionDisabled: data.length >= 5,
    },
    getRowId: (originalRow) => String(originalRow.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table} className="font-medium">
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
